export default __webpack_public_path__ + "static/media/boomerang.219f1702.png";